var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f6be00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.828 -1.828)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.813,11.7a2.36,2.36,0,0,1-2.36-2.36V4.188a2.36,2.36,0,0,1,4.72,0V9.337a2.36,2.36,0,0,1-2.36,2.36Z",
    transform: "translate(8.015 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.813,37.572a2.36,2.36,0,0,1-2.36-2.36V30.063a2.36,2.36,0,1,1,4.72,0v5.149a2.36,2.36,0,0,1-2.36,2.36Z",
    transform: "translate(8.015 14.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.768,14.457A2.36,2.36,0,0,1,25.1,10.429l3.64-3.64a2.36,2.36,0,0,1,3.336,3.336l-3.64,3.64a2.352,2.352,0,0,1-1.667.691Z",
    transform: "translate(12.524 2.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.471,32.784A2.36,2.36,0,0,1,6.8,28.755l3.64-3.64a2.36,2.36,0,1,1,3.336,3.336l-3.64,3.64a2.354,2.354,0,0,1-1.669.693Z",
    transform: "translate(2.252 12.508)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.212,21.173H30.063a2.36,2.36,0,1,1,0-4.72h5.149a2.36,2.36,0,0,1,0,4.72Z",
    transform: "translate(14.256 8.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.337,21.173H4.188a2.36,2.36,0,1,1,0-4.72H9.337a2.36,2.36,0,0,1,0,4.72Z",
    transform: "translate(0 8.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.394,32.753a2.354,2.354,0,0,1-1.669-.693l-3.64-3.64a2.36,2.36,0,0,1,3.336-3.336l3.64,3.64a2.36,2.36,0,0,1-1.667,4.029Z",
    transform: "translate(12.54 12.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.1,14.457a2.348,2.348,0,0,1-1.667-.691l-3.64-3.64a2.36,2.36,0,0,1,3.336-3.336l3.64,3.64A2.36,2.36,0,0,1,12.1,14.457Z",
    transform: "translate(2.267 2.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.77,32.711A10.942,10.942,0,1,1,32.711,21.77,10.942,10.942,0,0,1,21.77,32.711Z",
    transform: "translate(5.058 5.058)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.9329f23c53618376a10e3e878343382b.svg";
export { ForwardRef as ReactComponent };